import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { useEffect, useState } from "react";
import { getMenus, CLEAR_STATE_PAGE } from "../../../Utils/types";
import {
  clearCurrentPage,
  clearDuration,
} from "../ProviderProfileDetails/helper";
import { useDispatch } from "react-redux";
import { getDispatch } from "../../../Utils/helper";
import { toggleMenuNetwork } from "../../../common/custom";

export const LeftSideBarNetworkPortal = () => {
  let navigate = useNavigate();
  const dispatch = useDispatch();
  const [isLogoutPopup, setIsLogoutPopup] = useState(false);

  useEffect(() => {
    const pathSegments = window.location.pathname.split("/");
    pathSegments.shift();
    pathSegments.shift();
    const newPath = pathSegments.join("/");
    if (getMenus()) {
      getMenus()?.map((ele) => {
        window.location.pathname.includes(ele?.menuItem?.url.split("/")[1]);
        if (ele?.menuItem?.url?.includes(newPath)) {
          localStorage.setItem("NetworkMenuId", JSON.stringify(ele?.menuItem));
        }
      });
    }
  }, [getMenus()]);

  return (
    <>
      <div
        className="sidebar-menu __custom_scroller__properties"
        id="sidebar-menu __custom_scroller__properties"
      >
        <ul className="__custom_ul">
          <div className="accordion accordion-leftside" id="accordionExample">
            {getMenus()?.map((ele, index) => {
              return (
                <div className="accordion-item" key={index}>
                  <button
                    className={`accordion-button ${
                      ele?.subMenus?.length ? "accordion-item-not" : ""
                    } ${
                      !window.location.pathname.includes(
                        ele?.menuItem?.url.split("/")[1]
                      )
                        ? "collapsed"
                        : ""
                    }`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse${ele?.menuItem?.menuId}`}
                    aria-expanded="true"
                    aria-controls="collapseOne"
                    onClick={() => {
                      {
                        ele?.subMenus?.length === 0 &&
                          clearCurrentPage(dispatch);
                      }
                      localStorage.setItem(
                        "NetworkMenuId",
                        JSON.stringify(ele?.menuItem)
                      );
                      !ele?.subMenus?.length && navigate(ele?.menuItem?.url);
                      clearDuration(dispatch);
                      ele?.subMenus?.length === 0 &&
                        window.innerWidth < 900 &&
                        toggleMenuNetwork();
                    }}
                  >
                    <i
                      className="fas fa-user-alt"
                      style={{ marginRight: "10px" }}
                    ></i>
                    {ele?.menuItem?.title}
                  </button>
                  <div
                    id={`collapse${ele?.menuItem?.menuId}`}
                    className="accordion-collapse collapse"
                    aria-labelledby="headingOne"
                    data-bs-parent="#accordionExample"
                  >
                    <div className="accordion-body">
                      {ele?.subMenus?.length
                        ? ele?.subMenus?.map((ele, index) => {
                            return (
                              <li
                                key={index}
                                style={{ cursor: "pointer" }}
                                className={`${
                                  window.location.pathname.includes(ele?.url)
                                    ? "active-color"
                                    : "black-color"
                                }`}
                                onClick={() => {
                                  clearCurrentPage(dispatch);
                                  localStorage.setItem(
                                    "NetworkMenuId",
                                    JSON.stringify(ele)
                                  );
                                  navigate(ele?.url);
                                  getDispatch(
                                    CLEAR_STATE_PAGE,
                                    Math.random(),
                                    dispatch
                                  );
                                  window.innerWidth < 900 &&
                                    toggleMenuNetwork();
                                }}
                              >
                                <i
                                  className={`fa-solid fa-minus me-3 ${
                                    window.location.pathname.includes(ele?.url)
                                      ? "active-color"
                                      : "black-color"
                                  }`}
                                ></i>
                                {ele?.title}
                              </li>
                            );
                          })
                        : null}
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </ul>
        <div className="logout" onClick={() => setIsLogoutPopup(true)}>
          <ul className="__custom_ul">
            <li>
              <a className="sidebar-links">
                <span className="custom-svg">
                  <img
                    src="https://uat.healthassure.in/ProvidersPortal/images/logoutIcon.png"
                    className="img-fluid"
                    alt=""
                  />
                </span>
                <span style={{ color: "#DD0000" }}>Logout</span>
              </a>
            </li>
          </ul>
        </div>
      </div>
      <Modal
        isOpen={isLogoutPopup}
        className="modal-confirmation-popup"
        overlayClassName="overlay-confirmation-popup network-z-index"
        ariaHideApp={false}
      >
        <div className="modal-body modal-body-active-popup popup-text">
          Are you sure you want to Logout ?
        </div>
        <div className="modal-footer modal-footer-active-popup">
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => {
              localStorage.clear();
              navigate("/");
              setIsLogoutPopup(false);
            }}
            style={{ width: "90px" }}
          >
            Yes
          </button>
          <button
            type="button"
            className="btn btn-primary btn-logout-no"
            onClick={() => setIsLogoutPopup(false)}
          >
            No
          </button>
        </div>
      </Modal>
    </>
  );
};
